import { useRef } from 'react'

export function useCalendarActionToken() {
  const actionTokenRef = useRef(0)

  function getActionToken() {
    return actionTokenRef.current
  }

  function handleStartAction() {
    actionTokenRef.current += 1
  }

  return { getActionToken, handleStartAction }
}
